import Cookies from "js-cookie";

export function logout(redirectPage) {
    window.localStorage.clear();
    Cookies.remove("userInfo");
    Cookies.remove("username");
    window.location.href = redirectPage;
}